import { render, staticRenderFns } from "./detalleFamiliaProducto.vue?vue&type=template&id=13c2f1ec&scoped=true&"
import script from "./detalleFamiliaProducto.vue?vue&type=script&lang=js&"
export * from "./detalleFamiliaProducto.vue?vue&type=script&lang=js&"
import style1 from "./detalleFamiliaProducto.vue?vue&type=style&index=1&id=13c2f1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2f1ec",
  null
  
)

export default component.exports